module.exports = __webpack_public_path__ + "img/java.908bcbe9.png";